import React from 'react';
import { Link } from 'react-scroll';
import { FacebookIcon, InstagramIcon, TwitterIcon } from '../../svg/icons';
import '../css/footer.scss';
import logo from '../../assets/images/logo1-preview.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../../components/css/lotteryCard.scss';
import watsap from '../../assets/images/watsap.png';
import facebook from '../../assets/images/facebook.jpg';
import instagram from '../../assets/images/instagram.png';
import twitter from '../../assets/images/twitter.png';
import youtube from '../../assets/images/youtube.png';

function Footer() {
  return (
<div>

    <div className="footer">
      <div className="left">
        <Link to="/">
          <img className="nav-logo" style={{width: 80, height: 80}} src={logo} alt="logo-LottoQuiz" />
        </Link>
      </div>
      <div className="cotainer justify-content-end d-flex me-4">
        <a
          target="_blank"
          className="watsapp mb-4"
          href="https://wa.me/584247336043"
        >
          <img src={watsap} className='watsappimg'/>
        </a>
        <a
          target="_blank"
          className="facebook mb-4"
          href="https://www.facebook.com/profile.php?id=100090370083338&mibextid=LQQJ4d"
        >
          <img src={facebook} className="facebookimg" />
        </a>
        <a
          target="_blank"
          className="instagram mb-4"
          href="https://instagram.com/lottoquiz.vzla?igshid=MzRlODBiNWFlZA=="
        >
          <img src={instagram} className="instagramimg" />
        </a>
        <a
          target="_blank"
          className="twitter mb-4"
          href="https://twitter.com/lottoquizvzla"
        >
          <img src={twitter} className="twitterimg" />
        </a>
        <a
          target="_blank"
          className="youtube mb-4"
          href="https://youtube.com/@lottoquiz"
        >
          <img src={youtube} className="youtubeimg" />
        </a>
      </div>
    </div> 
    </div>
  );
}

export default Footer;
